<template>
  <DatePicker v-model="value" :shortLocale="shortLocale" :staticInput="true" :time-picker="true" :format="format" :min-date="minDate" :max-date="maxDate" :placeholder="placeholder" />
</template>

<script>
export default {
  props: ['shortLocale', 'minDate', 'maxDate', 'modelValue', 'format', 'placeholder'],
  emits: ['update:modelValue'],
  computed: {
    value: {
      get () {
        return this.modelValue
      },
      set (value) {
        this.$emit('update:modelValue', value)
      }
    }
  }
}
</script>
